"use client";

import { c as _c } from "react/compiler-runtime";
import React, { useState } from "react";
import styles from "@/features/partner-with-us/BusinessDetailsForm/main.module.css";
import Modal from "@/features/partner-with-us/Model";
import UniversalButton from "@/components/common/UniversalButton";
const TermsText: React.FC = () => {
  const $ = _c(4);
  const [open, setOpen] = useState(false);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className={styles.termsText}>By signing up, I agree to the{" "}<UniversalButton classNames={styles.termsLink} text="Terms & Conditions" onClick={() => setOpen(true)} variant="custom" type="button" /></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => setOpen(false);
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== open) {
    t2 = <>{t0}<Modal isOpen={open} onClose={t1} /></>;
    $[2] = open;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
};
export default TermsText;